export function setsEqual<T>(a: Set<T>, b: Set<T>): boolean {
  if (a === b) return true
  if (a.size !== b.size) return false
  for (const item of a) if (!b.has(item)) return false
  return true
}
